import { Injectable } from '@angular/core';
import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { FILTER_SELECTION_ENTITY_NAME } from '../const';
import { FilterSelectionState } from '../models';

@Injectable({ providedIn: 'root' })
export class FilterSelectionStore extends EntityCollectionServiceBase<FilterSelectionState> {
  constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory) {
    super(FILTER_SELECTION_ENTITY_NAME, serviceElementsFactory);
  }
}
